import { SET_CHATBOT_STATE } from "../actions/chatbotAction";

const initialState = {
    showChatbot: true,
    isOpen: false,
    conversation: [],
    inputValue: "",
    loading: false,

    timerEnabled: true,
    timeLeft: 60,
    lastActivity: Date.now(),

    currentBotText: "", // kept for backward-compat; UI will use msg.liveText instead
    listening: false,
    fullscreenMode: false,

    position: { x: window.innerWidth - 80, y: window.innerHeight - 80 },

    isTypingStopped: false,
};

export default function chatbotReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CHATBOT_STATE:
            return { ...state, ...action.data };

        // Append messages using latest state (prevents stale closure problems)
        case "CHAT_APPEND_MESSAGES":
            return { ...state, conversation: [...state.conversation, ...action.data] };

        // Update a single message by id (prevents wrong message updates)
        case "CHAT_UPDATE_MESSAGE":
            return {
                ...state,
                conversation: state.conversation.map((m) =>
                    m.id === action.data.id ? { ...m, ...action.data.patch } : m
                ),
            };

        default:
            return state;
    }
}
